import React, { useState, useEffect } from 'react'
import axios from 'axios';
import MyNavBar from './myNavBar.js'
import { Container, Row, Col } from 'react-bootstrap';
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function MyUserManagement(params) {
  let basurl = window.location.hostname
  let userName = localStorage.getItem("userName");
  let companyId = localStorage.getItem("Company");

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [passWord, setPassWord] = useState('');
  const [userTypeId, setUserTypeId] = useState(0)
  const [userTypes, setUserTypes] = useState([])
  const [companies, setCompanies] = useState([])
  const [userCompanyId, setUserCompanyId] = useState(0);
  const [active, setActive] = useState(true);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(0);
  const [edit, setEdit] = useState(0)
  const [selectUserId, setSelectUserId] = useState(0)

    useEffect(() => {
      const url1 = `http://${basurl}:9091/api/User/UserTypes`
      axios.get(url1, {
        params: {
          companyId: companyId
        }
      })
        .then(res1 => {
          setUserTypes(res1.data);
        });
  
        const url2 = `http://${basurl}:9091/api/User/getCompanies`
        axios.get(url2, {
          params: {
            companyId: companyId
          }
        })
          .then(res2 => {
            setCompanies(res2.data);
          });
    }, [])

    const handleGerUsers=()=>{
      console.log(users);
      setEdit(0);
      const url1 = `http://${basurl}:9091/api/User/getUsers`
      axios.get(url1, {
        params: {
          companyId: companyId
        }
      })
        .then(res1 => {
          let userList=res1.data;
          userList.map(e=> e["selected"]=0)
          setUsers(userList)
        });
        renderTableData();
    }

    function handleSelection(e) {
      let selectedID = e.target.value;
      users.map((user) => {
        if (user._id ===selectedID & user["selected"] === 0) {
          user["selected"] = 1
        } else if (user._id === selectedID & user["selected"] === 1) {
          user["selected"] = 0
        }
      });
    }

    function renderTableData() {
      return users.map((user, index) => {
        const { _id, name, email, password, active, company,userType } = user //destructuring
        console.log(company);
        console.log(companies);
        let companyName=company&&companies&&companies.length&&companies.find(e=>parseInt(e.value)===parseInt(company)).label,
        userTypeName=userType&&userTypes&&userTypes.length&&userTypes.find(e=>e["_id"]===userType).description
        return (
          <tr key={_id}>
            <td><input type="checkbox" selected={selected} onChange={handleSelection} value={_id} name="_id" />&nbsp;</td>
            <td>{_id}</td>
            <td>{name}</td>
            <td>{email}</td>
            <td>{password}</td>
            <td>{active?"Aktif":"Pasif"}</td>
            <td>{companyName}</td>
            <td>{userTypeName}</td>
          </tr>
        )
      })
    }

    function handleEditClick() {
      console.log("handleEditClick");
      console.log(users);
      if (users.filter(user => user["selected"] === 1).length === 0) {
        toast.warning("Kullanıcı seçilmemiş. Lütfen kontrol edip tekrar deneyin!")
      }
      if (users.filter(user => user["selected"] === 1).length > 1) {
        toast.warning("Birden fazla kullanıcı seçilmiş. Aynı anda sadece bir kayıt düzenlenebilir. Lütfen kontrol edip tekrar deneyin!")
      }
      if (users.filter(product => product["selected"] === 1).length === 1) {
        setSelectUserId((users.find(user => user["selected"] === 1))["_id"])
        setEmail((users.find(user => user["selected"] === 1))["email"]);
        setName((users.find(user => user["selected"] === 1))["name"]);
        setPassWord((users.find(user => user["selected"] === 1))["password"]);
        setUserTypeId((users.find(user => user["selected"] === 1))["userType"]);
        setUserCompanyId((users.find(user => user["selected"] === 1))["company"]);
        setEdit(1)
      }
    };


    const handleSubmit=()=>{
      if(!email){
        toast.error("Email adresi girilmeden kullanıcı kayıt edemezsiniz!");
      }else{
        fetch(`http://${basurl}:9091/api/User/createUser`, {
          method: "POST",
          redirect: "follow",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userName:userName,
            companyId: companyId,
            email: email,
            name: name,
            password:passWord,
            active: active,
            userTypeId:userTypeId,
            userCompanyId:userCompanyId,
            selectUserId:selectUserId,
            edit:edit
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            if(data.warning){
              toast.error(data.warning);
            }else  {
              toast.info("kayıt işlemi başarılı bir şekilde gerçekleşti!");
              setTimeout(()=>
              window.location.href = `/myUserManagement/`,2000
              )
             }
          })
          .catch((err) => console.log(err.response.data));
      }
    }
    
    useEffect(()=>{
      console.log(userCompanyId);
    },[userCompanyId])

  return (
      <div className="Form1">
        <MyNavBar conpanyID={companyId}></MyNavBar>
      <ToastContainer draggable pauseOnHover newestOnTop={true} position="top-center" />
      <form className="Form2">
        <Container fluid className="border border-info">
          <Row>
            <Col sm={4}>
              <input type="text" placeholder="E-mail" required name="email" value={email} onChange={e => setEmail(e.target.value)} className="form-control" />
            </Col>
            <Col sm={4}>
              <input type="text" placeholder="Ad-Soyad" required name="name" value={name} onChange={e => setName(e.target.value)} className="form-control" />
            </Col>
            <Col sm={4}>
              <input type="text" placeholder="Şifre" required name="Şifre" value={passWord} onChange={e => setPassWord(e.target.value)} className="form-control" />
            </Col>
          </Row>
          <Row>
          <Col sm={6}>
              <select name="userTypeId" required value={userTypeId} onChange={e => setUserTypeId(e.target.value)} className="form-control">
                <option value="0" disabled>Kullanıcı Tipi Seçiniz...</option>
                {userTypes.map(data => <option key={data["_id"]} value={data["_id"]}>{data.description}</option>)}</select>
            </Col>
            <Col sm={6}>
            <Select required placeholder={<div>Mudi Seçiniz !</div>}     
            value = {companies.filter(e => parseInt(e.value) === parseInt(userCompanyId))} 
            onChange={(e) => setUserCompanyId(e.value)} options={companies} />
            </Col>
          </Row>&nbsp;
          <Row>
          <Col sm={4}>
              <b>Aktif?</b>&nbsp;&nbsp;&nbsp;&nbsp;
              <input type="checkbox" checked={active} required name="active" onChange={e => setActive(e.target.checked)} />
            </Col>
            </Row>
        </Container>
        </form>
        <Container fluid className="border border-info">
          <Row>
            <Col sm={4}>
              <button
                type="button"
                style={{ width: "100%", height: "30px" }}
                value="submit"
                onClick={handleSubmit}
                className="btn btn-success"
              >
                Kaydet
              </button>
            </Col>
            <Col sm={4}>
              <button
                type="button"
                style={{ width: "100%", height: "30px" }}
                value="submit"
                onClick={handleGerUsers}
                className="btn btn-warning"
              >
                Sorgula
              </button>
            </Col>
            <Col sm={4}>
              <button
                type="button"
                style={{ width: "100%", height: "30px" }}
                value="submit"
                onClick={handleEditClick}
                className="btn btn-primary"
              >
                Düzenle
              </button>
            </Col>
          </Row>
        </Container>&nbsp;&nbsp;
        <Container fluid>
          <Row>
            <Col>
            <table id="table-to-xls" className="Form1">
              <thead>
                <tr>
                <td>Seç</td>
                  <td>Id</td>
                  <td>Ad-Soyad</td>
                  <td>Email</td>
                  <td>Şifre</td>
                  <td>Aktif</td>
                  <td>Şirket</td>
                  <td>Kullanıcı Tipi</td>
                </tr>
              </thead>
          <tbody className="show-grid">
            {renderTableData()}
          </tbody>
        </table>

            </Col>
          </Row>
        </Container>
        
      </div>
  )
}

export default MyUserManagement;
